import React, { useRef, Component } from 'react';
import { motion, useInView } from 'framer-motion';
import { CrownIcon, LinkIcon, BrainIcon, ZapIcon, TheaterIcon, DropletsIcon, HeartHandshakeIcon, SparklesIcon, CheckIcon } from 'lucide-react';
type Service = {
  title: string;
  price: string;
  description?: string;
  icon: ComponentType<{
    size?: number;
    className?: string;
  }>;
};
const CALL_FOR_PRICING = 'Call for Pricing';
const dominanceSessions: Service[] = [{
  title: 'Discipline Session',
  price: CALL_FOR_PRICING,
  description: 'Structured obedience, protocol, and behavioral training.',
  icon: CrownIcon
}, {
  title: 'Bondage Session',
  price: CALL_FOR_PRICING,
  description: 'Classical rope work, restraint, and refined immobilization.',
  icon: LinkIcon
}, {
  title: 'Psychological Domination',
  price: CALL_FOR_PRICING,
  description: 'Mind-focused control, surrender, and mental submission.',
  icon: BrainIcon
}, {
  title: 'Impact Play Session',
  price: CALL_FOR_PRICING,
  description: 'Skillful implement work — calibrated for intensity and safety.',
  icon: ZapIcon
}, {
  title: 'Role Play Experience',
  price: CALL_FOR_PRICING,
  description: 'Immersive scenarios tailored to your fantasy and psychology.',
  icon: TheaterIcon
}];
const wellnessSessions: Service[] = [{
  title: 'Nuru Session',
  price: CALL_FOR_PRICING,
  description: 'The traditional Japanese body-to-body ritual.',
  icon: DropletsIcon
}, {
  title: 'Sensual Massage · 30 min',
  price: CALL_FOR_PRICING,
  description: 'Focused, intentional touch.',
  icon: HeartHandshakeIcon
}, {
  title: 'Sensual Massage · 45 min',
  price: CALL_FOR_PRICING,
  description: 'Extended attention and presence.',
  icon: HeartHandshakeIcon
}, {
  title: 'Sensual Massage · 60 min',
  price: CALL_FOR_PRICING,
  description: 'The full restorative experience.',
  icon: HeartHandshakeIcon
}];
const addOns = ['Jacuzzi Soak', 'Prostate Massage', 'Ass Worship', 'Pegging', 'Cuddling', 'Milking Wedge'];
export function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="experiences" ref={ref} className="py-24 lg:py-32 bg-onyx relative overflow-hidden" data-id="element-302">
      {/* Decorative purple glow accents */}
      <div className="absolute top-1/4 -left-32 w-96 h-96 bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-303"></div>
      <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-aubergine/30 rounded-full blur-3xl pointer-events-none" data-id="element-304"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-305">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-306">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-307">
            Investment
          </p>
          <h2 className="font-cormorant text-bone text-4xl lg:text-6xl font-light mb-6" data-id="element-308">
            Services & Rates
          </h2>
          <p className="text-silver-muted text-lg max-w-2xl mx-auto" data-id="element-309">
            A curated menu of dominance and sensual wellness experiences. Each
            session is tailored to your desires, boundaries, and journey.
          </p>
        </motion.div>

        {/* Editorial split banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1,
        delay: 0.2
      }} className="grid md:grid-cols-2 gap-0 mb-20 border border-gold/15" data-id="element-310">
          <div className="relative aspect-[4/5] overflow-hidden" data-id="element-311">
            <img src="https://cdn.magicpatterns.com/uploads/dPot6R3X5y6d5iGavzUDii/13.jpg" alt="Madam Yas" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-312" />
          </div>
          <div className="bg-ink p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-313">
            <p className="text-gold font-cinzel text-xs tracking-[0.4em] mb-4" data-id="element-314">
              THE PRACTICE
            </p>
            <p className="font-cormorant text-bone text-2xl md:text-3xl lg:text-4xl font-light italic leading-snug mb-6" data-id="element-315">
              "Power, properly held, is a form of generosity."
            </p>
            <p className="text-silver-muted text-sm leading-relaxed" data-id="element-316">
              Each session is approached as a craft — the result of training,
              attention, and an unwavering respect for the person across from
              me.
            </p>
            <div className="mt-8 pt-6 border-t border-gold/20" data-id="element-317">
              <p className="text-gold font-cinzel text-xs tracking-[0.3em]" data-id="element-318">
                — MADAM YAS
              </p>
            </div>
          </div>
        </motion.div>

        {/* Dominance Sessions */}
        <ServiceGroup eyebrow="I." title="Dominance Sessions" subtitle="The art of power exchange — structured, intentional, and unflinching." services={dominanceSessions} isInView={isInView} data-id="element-319" />

        {/* Sensual Wellness Sessions */}
        <ServiceGroup eyebrow="II." title="Sensual Wellness Sessions" subtitle="Restorative, embodied experiences for the senses." services={wellnessSessions} isInView={isInView} data-id="element-320" />

        {/* Premium Add-Ons */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-20" data-id="element-321">
          <div className="text-center mb-10" data-id="element-322">
            <p className="text-gold font-cinzel text-xs tracking-[0.4em] mb-3" data-id="element-323">
              III.
            </p>
            <h3 className="font-cormorant text-bone text-3xl lg:text-4xl font-light mb-3" data-id="element-324">
              Premium Add-Ons
            </h3>
            <p className="text-silver-muted text-sm max-w-xl mx-auto" data-id="element-325">
              Elevate any qualifying session. Call for pricing.
            </p>
          </div>

          <div className="relative bg-ink border border-gold/20 p-8 md:p-12 shadow-[0_0_60px_rgba(183,148,212,0.08)]" data-id="element-326">
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-10 gap-y-5" data-id="element-327">
              {addOns.map((addon, index) => <motion.div key={addon} initial={{
              opacity: 0,
              x: -10
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.4 + index * 0.07
            }} className="flex items-center gap-4 group" data-id="element-328">
                  <div className="w-9 h-9 border border-gold/30 flex items-center justify-center flex-shrink-0 group-hover:border-gold group-hover:bg-gold/10 transition-all" data-id="element-329">
                    <CheckIcon size={14} className="text-gold" data-id="element-330" />
                  </div>
                  <div className="flex-1 flex items-baseline border-b border-gold/10 pb-3" data-id="element-331">
                    <span className="font-cormorant text-bone text-lg" data-id="element-332">
                      {addon}
                    </span>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>

        {/* Call to Action */}
        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-20" data-id="element-333">
          <p className="text-silver-muted text-xs uppercase tracking-[0.25em] mb-8" data-id="element-334">
            Extended sessions, travel, and bespoke arrangements available upon
            inquiry
          </p>
          <a href="#contact" className="inline-flex items-center gap-3 px-10 py-5 text-base uppercase tracking-[0.2em] font-semibold border-2 transition-all duration-300 shadow-[0_0_30px_rgba(183,148,212,0.25)] hover:shadow-[0_0_50px_rgba(183,148,212,0.5)]" style={{
          backgroundColor: '#B794D4',
          color: '#07050A',
          borderColor: '#B794D4'
        }} data-id="element-335">
            Book a Private Consultation
            <span aria-hidden data-id="element-336">→</span>
          </a>
        </motion.div>
      </div>
    </section>;
}
// ─────────────────────────────────────────────────────────────────────────────
// Reusable service group
// ─────────────────────────────────────────────────────────────────────────────
function ServiceGroup({
  eyebrow,
  title,
  subtitle,
  services,
  isInView
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
  services: Service[];
  isInView: boolean;
}) {
  return <div className="mb-20 last:mb-0" data-id="element-337">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="text-center mb-10" data-id="element-338">
        <p className="text-gold font-cinzel text-xs tracking-[0.4em] mb-3" data-id="element-339">
          {eyebrow}
        </p>
        <h3 className="font-cormorant text-bone text-3xl lg:text-4xl font-light mb-3" data-id="element-340">
          {title}
        </h3>
        <p className="text-silver-muted text-sm max-w-xl mx-auto" data-id="element-341">{subtitle}</p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-342">
        {services.map((service, index) => {
        const Icon = service.icon;
        return <motion.div key={service.title + service.price} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.08
        }} className="relative bg-ink border border-gold/15 p-8 flex flex-col group transition-all duration-500 hover:border-gold/50 hover:shadow-[0_0_40px_rgba(183,148,212,0.15)]" data-id="element-343">
              {/* Top accent line */}
              <div className="absolute top-0 left-0 w-12 h-px bg-gold group-hover:w-full transition-all duration-500" data-id="element-344"></div>

              <div className="w-12 h-12 border border-gold/30 flex items-center justify-center mb-6 group-hover:border-gold group-hover:bg-gold/5 transition-all" data-id="element-345">
                <Icon size={20} className="text-gold" data-id="element-346" />
              </div>

              <h4 className="font-cormorant text-bone text-2xl mb-3 group-hover:text-gold transition-colors leading-tight" data-id="element-347">
                {service.title}
              </h4>

              {service.description && <p className="text-silver-muted text-sm leading-relaxed flex-1 mb-6" data-id="element-348">
                  {service.description}
                </p>}

              <div className="pt-5 border-t border-gold/20" data-id="element-349">
                <p className="text-gold font-cinzel text-sm tracking-[0.2em] uppercase" data-id="element-350">
                  {service.price}
                </p>
              </div>
            </motion.div>;
      })}
      </div>
    </div>;
}